import React from 'react';
import { BookOpenIcon, CheckCircleIcon, BarChartIcon } from 'lucide-react';
export const Authority = () => {
  return <section id="solution" className="w-full bg-blue-50 py-12 px-4 md:px-8" data-id="element-9">
      <div className="max-w-5xl mx-auto" data-id="element-10">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-11">
          Odkrycie, które obaliło wszystko, w co wierzyłam
        </h2>
        {/* Doctor authority section */}
        <div className="bg-white rounded-lg shadow-md p-6 md:p-8 mb-12" data-id="element-12">
          <div className="md:flex items-start" data-id="element-13">
            <div className="md:w-1/3 mb-6 md:mb-0 md:mr-6" data-id="element-14">
              <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Dr Joanna Radacka" className="rounded-lg shadow-md w-full" data-id="element-15" />
              <div className="bg-blue-100 rounded-lg p-3 mt-3" data-id="element-16">
                <p className="text-sm text-gray-700 font-bold" data-id="element-17">
                  Dr Joanna Radacka
                </p>
                <p className="text-xs text-gray-600" data-id="element-18">
                  Psychiatra, specjalistka ds. wypalenia opiekunów
                </p>
                <p className="text-xs text-gray-600 mt-1" data-id="element-19">
                  Autorka przełomowych badań nad "pokoleniem kanapkowym"
                </p>
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-20">
              <p className="text-gray-700 mb-4" data-id="element-21">
                Trafiłam na artykuł dr Joanny Radackiej, psychiatry
                specjalizującej się w wypaleniu opiekunów. Pisała coś, co
                kompletnie mnie zaskoczyło:
              </p>
              <div className="bg-blue-50 border-l-4 border-blue-500 p-4 my-4" data-id="element-22">
                <p className="text-gray-700 italic" data-id="element-23">
                  "Kobiety z pokolenia kanapkowego - te, które opiekują się
                  jednocześnie dziećmi i rodzicami - są w stanie chronicznego
                  przeciążenia emocjonalnego. Ich mózg funkcjonuje w trybie
                  ciągłego alarmu, co prowadzi do całkowitego wyczerpania
                  zasobów psychicznych."
                </p>
              </div>
              <p className="text-gray-700 font-bold mb-4" data-id="element-24">
                Ale to, co przeczytałam dalej, było jeszcze bardziej szokujące:
              </p>
              <p className="text-gray-700 mb-4" data-id="element-25">
                Dr Radacka opublikowała badania przeprowadzone na grupie 2847
                kobiet w wieku 35-55 lat. Wyniki były alarmujące:
              </p>
              <div className="bg-gray-100 rounded-lg p-5 my-6" data-id="element-26">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-27">
                  <div className="bg-white p-4 rounded-lg shadow-sm text-center" data-id="element-28">
                    <div className="text-3xl font-bold text-red-600 mb-2" data-id="element-29">
                      89%
                    </div>
                    <p className="text-gray-700 text-sm" data-id="element-30">
                      kobiet z pokolenia kanapkowego cierpi na chroniczny stres
                    </p>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-sm text-center" data-id="element-31">
                    <div className="text-3xl font-bold text-red-600 mb-2" data-id="element-32">
                      76%
                    </div>
                    <p className="text-gray-700 text-sm" data-id="element-33">
                      doświadcza objawów wypalenia emocjonalnego
                    </p>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-sm text-center" data-id="element-34">
                    <div className="text-3xl font-bold text-red-600 mb-2" data-id="element-35">
                      63%
                    </div>
                    <p className="text-gray-700 text-sm" data-id="element-36">
                      ma problemy z kontrolą emocji (wybuchy złości, płacz)
                    </p>
                  </div>
                </div>
              </div>
              <p className="text-gray-700 font-bold text-xl" data-id="element-37">
                Ale najważniejsze odkrycie było inne...
              </p>
            </div>
          </div>
        </div>
        {/* Why traditional methods fail */}
        <div className="bg-white rounded-lg shadow-md p-6 md:p-8 mb-12" data-id="element-38">
          <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-6" data-id="element-39">
            Dlaczego wszystkie dotychczasowe "rozwiązania" nie działały
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-40">
            Dr Radacka wyjaśniła coś, czego nikt mi wcześniej nie powiedział:
          </p>
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 my-4" data-id="element-41">
            <p className="text-gray-700 italic" data-id="element-42">
              "Większość tradycyjnych metod radzenia sobie ze stresem - jak
              planery, aplikacje do medytacji czy porady o 'work-life balance' -
              są stworzone dla ludzi w normalnym stresie. Nie dla kobiet z
              pokolenia kanapkowego."
            </p>
          </div>
          <h4 className="text-lg font-bold text-gray-800 mt-6 mb-4" data-id="element-43">
            Dlaczego te metody zawodzą?
          </h4>
          <div className="space-y-4 my-6" data-id="element-44">
            <div className="flex items-start" data-id="element-45">
              <div className="text-red-500 mr-3 mt-1" data-id="element-46">🚫</div>
              <div data-id="element-47">
                <p className="font-bold text-gray-800" data-id="element-48">
                  Planery i organizacja czasu
                </p>
                <p className="text-gray-700" data-id="element-49">
                  Nie możesz "zaplanować" kiedy mama zapomni gdzie jest łazienka
                  czy kiedy dziecko zachoruje
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-50">
              <div className="text-red-500 mr-3 mt-1" data-id="element-51">🚫</div>
              <div data-id="element-52">
                <p className="font-bold text-gray-800" data-id="element-53">
                  Klasyczne techniki relaksacyjne
                </p>
                <p className="text-gray-700" data-id="element-54">
                  Wymagają ciszy i spokoju, którego po prostu nie masz
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-55">
              <div className="text-red-500 mr-3 mt-1" data-id="element-56">🚫</div>
              <div data-id="element-57">
                <p className="font-bold text-gray-800" data-id="element-58">
                  Rady o delegowaniu obowiązków
                </p>
                <p className="text-gray-700" data-id="element-59">
                  Komu masz delegować opiekę nad chorym rodzicem?
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-60">
              <div className="text-red-500 mr-3 mt-1" data-id="element-61">🚫</div>
              <div data-id="element-62">
                <p className="font-bold text-gray-800" data-id="element-63">
                  Coaching "work-life balance"
                </p>
                <p className="text-gray-700" data-id="element-64">
                  Ignoruje fakt, że opieka nad rodzicem to 24/7, nie "work"
                </p>
              </div>
            </div>
          </div>
          <p className="text-gray-700 mb-4" data-id="element-65">
            Dr Radacka odkryła coś rewolucyjnego:
          </p>
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 my-4" data-id="element-66">
            <p className="text-gray-700 italic" data-id="element-67">
              "Mózg kobiet z pokolenia kanapkowego znajduje się w stanie, który
              nazywam 'neurologicznym zamknięciem'. Tradycyjne metody nie
              działają, bo próbują wpłynąć na system, który jest już
              przeciążony."
            </p>
          </div>
          <p className="text-gray-700 font-bold" data-id="element-68">
            To było jak olśnienie. W końcu ktoś rozumiał, dlaczego nic nie
            pomagało.
          </p>
        </div>
        {/* Scientific credibility section */}
        <div className="bg-blue-100 rounded-lg p-6 md:p-8 text-center" data-id="element-69">
          <div className="flex justify-center mb-4" data-id="element-70">
            <BookOpenIcon className="h-12 w-12 text-blue-600" data-id="element-71" />
          </div>
          <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-72">
            Badania naukowe potwierdzają
          </h3>
          <div className="flex flex-wrap justify-center items-center gap-4 my-6" data-id="element-73">
            <img src="https://cdn.pixabay.com/photo/2022/01/30/13/33/github-6980894_1280.png" alt="Logo Uniwersytetu" className="h-12 opacity-70" data-id="element-74" />
            <img src="https://cdn.pixabay.com/photo/2017/01/31/13/14/animal-2023924_960_720.png" alt="Logo Instytutu" className="h-12 opacity-70" data-id="element-75" />
            <img src="https://cdn.pixabay.com/photo/2017/02/18/19/20/logo-2078018_960_720.png" alt="Logo Fundacji" className="h-12 opacity-70" data-id="element-76" />
          </div>
          <p className="text-gray-700" data-id="element-77">
            Badania przeprowadzone na grupie{' '}
            <span className="font-bold" data-id="element-78">2847 kobiet</span> w wieku 35-55 lat
          </p>
          <p className="text-gray-700 mt-2" data-id="element-79">
            Opublikowane w renomowanych czasopismach naukowych
          </p>
        </div>
      </div>
    </section>;
};